/* N1 · Al abrir un acordeón en la ficha de producto (móvil), lo colocamos justo debajo de todo lo que queda fijo arriba:
   cabecera de la tienda + barra fija con el nombre del guante. */
(function(){
if(window.N1AccScroll)return;window.N1AccScroll=1;
var SEL='.header, header, .shopify-section--header, .shopify-section-group-header-group, [class*="sticky"], [id*="sticky"], [data-sticky], .n1-pdp-bar, .n1-sticky';
function topOffset(){
  var bottom=0;
  document.querySelectorAll(SEL).forEach(function(el){
    if(!el.getClientRects().length)return;
    var cs=getComputedStyle(el);
    if(cs.position!=='fixed'&&cs.position!=='sticky')return;
    if(cs.visibility==='hidden'||cs.opacity==='0')return;
    var r=el.getBoundingClientRect();
    if(r.height<10||r.height>260)return;      // ignora cosas enormes o invisibles
    if(r.top>140)return;                       // solo lo que está pegado arriba
    if(r.bottom>bottom)bottom=r.bottom;
  });
  return bottom;
}
function go(el){
  if(!el)return;
  var off=topOffset();
  var y=window.pageYOffset+el.getBoundingClientRect().top-off-12;
  window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
  // segundo ajuste: tras el scroll, la barra fija puede cambiar de altura
  setTimeout(function(){
    var off2=topOffset();
    var r=el.getBoundingClientRect();
    if(r.top<off2+4||r.top>off2+60){
      window.scrollTo({top:Math.max(0,window.pageYOffset+r.top-off2-12),behavior:'smooth'});
    }
  },520);
}
function host(t){return t.closest('details, .accordion, [class*="accordion"], .product-info__block-item');}
function inProduct(el){return !!el.closest('.product-info, .shopify-section--main-product, product-info, .n1-pdp');}
document.addEventListener('toggle',function(e){
  var d=e.target;
  if(!d||d.tagName!=='DETAILS'||!d.open)return;
  if(window.innerWidth>749||!inProduct(d))return;
  setTimeout(function(){go(d)},300);
},true);
document.addEventListener('click',function(e){
  if(window.innerWidth>749)return;
  var t=e.target.closest('summary, button, [role="button"]');
  if(!t||!inProduct(t))return;
  var box=host(t);if(!box)return;
  setTimeout(function(){
    var opened=box.open===true||box.getAttribute('aria-expanded')==='true'||box.classList.contains('is-open')||box.classList.contains('open')||t.getAttribute('aria-expanded')==='true';
    if(opened)go(box);
  },320);
},true);
})();
